import styled from 'styled-components'

export default styled.table`
    width: 100%;
    max-width: 100%;
    margin-bottom: 1rem;
    background-color: transparent;

    td,
    th {
      padding: .75rem;
      vertical-align: top;
      border-top: 1px solid ${({ theme }) => theme.borderColor};
    }

    th {
      vertical-align: bottom;
      border-bottom: 2px solid ${({ theme }) => theme.borderColor};
    }
`
